import { Component, computed, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService, CustomerService } from '@core';
import { OrderStepBaseComponent } from '../../order-step-base-component';
import { OrderState } from 'app/order/models';
import { Product } from '@models/product';
import { toSignal } from '@angular/core/rxjs-interop';
import { orderProductHasTag } from 'app/products/fns';

@Component({
    selector: 'app-product-description-fallback',
    templateUrl: './product-description-fallback.component.html',
    styleUrls: ['./product-description-fallback.component.scss'],
    standalone: false,
})
export class ProductDescriptionFallbackComponent extends OrderStepBaseComponent {
    private authService = inject(AuthService);

    private customer = toSignal(inject(CustomerService).customer$);

    protected displayPrice = computed(() => this.insuranceType().pricePerSettlementPeriod);
    protected settlementPeriod = computed(() => this.insuranceType().settlementPeriod);

    protected schema = computed(() => this.buildSchema(this.product()));

    protected availableForUser = computed(() => {
        const isCompany = this.customer()?.title && this.customer()?.title.id === environment.titleCompanyId;

        return !isCompany || !this.product().orderConfig.naturalPersonsOnly;
    });

    protected showCustomerServiceNumber = orderProductHasTag('showCustomerServiceNumber');

    public getData(): Partial<OrderState> {
        return {};
    }

    public logout(): void {
        this.authService.logout();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private buildSchema(product: Product): { [key: string]: any } {
        return {
            '@context': 'https://schema.org/',
            '@type': 'Product',
            name: product.title,
            image: [product.presentation.imageUrl],
            description: product.presentation.imageAlt,
            brand: {
                '@type': 'Brand',
                name: 'astra Versicherung AG',
            },
            offers: {
                '@type': 'Offer',
                url: window.location.href,
                priceCurrency: 'EUR',
                price: (this.displayPrice() + '').replace(',', '.'),
                seller: {
                    '@type': 'Organization',
                    name: 'astra Versicherung AG',
                },
            },
        };
    }
}
